import { deleteArea } from "../../../../../actions/Utilities/Area";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteArea = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteArea(ids), {
    onSuccess: (res) => {
      queryClient.invalidateQueries(["GetArea"]);
      toast.fire("Success", "Area has been deactivated successfully", "success");
    },
    onError: (error) => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Area",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteArea;
